const pathname = {
  LANDING: '/',
  LOGIN: 'login',
  RECOVER_PASSWORD: '/resetPassword',
  NEW_USER_PASSWORD: '/newUser',
}

const appPathname = {
  NOTFOUND_MAIN: '/*',
  NOTFOUND: '/app/*',
  HOME: '/app/home',
  PROFILE: '/app/profile',
  // Estaciones de carburantes
  FUELSTATIONS: '/app/fuel-stations',
  FUELSTATIONS_OWN: '/app/fuel-stations/own-stations',
  FUELSTATIONS_FAVORITES: '/app/fuel-stations/favorite-stations',
  FUELSTATIONS_SPAIN: '/app/fuel-stations/spain-stations',
  FUELSTATIONS_PRICE_CHANGE: '/app/fuel-stations/price-change-stations',
  FUELSTATIONS_SETTINGS: '/app/fuel-stations/settings',
  // Estación de carburante
  FUELSTATION_OWN: (id) => `/app/fuel-station/own/data${id}`,
  FUELSTATION_OWN_COMPETENCES: (id) =>
    `/app/fuel-station/own/${id}/competences`,
  FUELSTATION_OWN_MINETUR_PRICES: (id) =>
    `/app/fuel-station/own/${id}/minetur_prices`,
  FUELSTATION_OWN_ALVIC_PRICES: (id) =>
    `/app/fuel-station/own/${id}/alvic_prices`,
  FUELSTATION_OWN_PURCHASE_PRICES: (id) =>
    `/app/fuel-station/own/${id}/purchase_prices`,
  FUELSTATION_OWN_STOCK: (id) => `/app/fuel-station/own/${id}/stock`,
  FUELSTATION_OWN_SALES: (id) => `/app/fuel-station/own/${id}/sales`,
  FUELSTATION_OWN_CONSUMPTION_PREVENTION: (id) =>
    `/app/fuel-station/own/${id}/consumptionsPrevention`,
  // Portal del empleado
  EMPLOYEE_PORTAL: '/app/employee',
  // Asiento contable
  ACCOUNTING_ENTRY: '/app/accounting-entry-g',
  ACCOUNTING_ENTRY_EMPLOYEES: '/app/accounting-entry-e',
  ACCOUNTING_ENTRY_CONCEPTS: '/app/accounting-entry-c',
}

export { pathname, appPathname }
